<tr @click="openFolder" style="cursor: pointer">
  <td class="text-center"><img src="@/assets/images/folder.png" class="w-20px" alt=""></td>
  <td class="text-xs text-dark">{{ folder.folder_name }}</td>
  <td class="text-xs text-dark">{{ folder.date_created }}</td>
  <td>
    <button
      class="btn btn-danger btn-sm text-xxs"
      @click.stop="delete_folder(folder.id)"
    >Delete</button>
  </td>
</tr>
